<script setup>
import { computed } from 'vue';
import { inboxDisplayName } from 'dashboard/helper/inboxDisplayName';

const props = defineProps({
  inbox: {
    type: Object,
    default: () => {},
  },
});

// A limpeza do nome vive em `inboxDisplayName` porque a busca rapida e o
// historico de conversas do contato precisam exibir exatamente o mesmo texto
// que este card mostra.
const displayName = computed(() => inboxDisplayName(props.inbox?.name));
</script>

<template>
  <div
    v-if="displayName"
    :title="displayName"
    class="flex items-center min-w-0"
  >
    <span class="truncate text-label-small text-n-slate-11">
      {{ displayName }}
    </span>
  </div>
</template>
